export var CampaignUpdateStatus;
(function (CampaignUpdateStatus) {
    CampaignUpdateStatus["Published"] = "Published";
    CampaignUpdateStatus["Unpublished"] = "Unpublished";
    CampaignUpdateStatus["Pending"] = "Pending";
    CampaignUpdateStatus["Failed"] = "Failed";
})(CampaignUpdateStatus || (CampaignUpdateStatus = {}));
